
export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative w-full h-96 lg:h-[500px] rounded-lg overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/d55016b224afa49376add18070d24dd4.jpg"
              alt="About Manohar International"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Content */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              About <span className="text-teal-600">Manohar International</span>
            </h2>
            <p className="text-base text-gray-600 mb-4 leading-relaxed">
              Manohar International is a distinguished private company specializing in premium spa, salon, and medical products. With years of expertise in the beauty and healthcare industry, we have established ourselves as a trusted partner for businesses seeking excellence.
            </p>
            <p className="text-base text-gray-600 mb-4 leading-relaxed">
              Our commitment to quality and innovation drives us to source and deliver only the finest products that meet international standards. We understand the unique needs of spa, salon, and medical professionals, and we pride ourselves on providing solutions that enhance their services and exceed their expectations.
            </p>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              From cutting-edge medical equipment to luxurious spa essentials and professional salon supplies, our comprehensive product range caters to diverse requirements. We believe in building lasting relationships with our clients through exceptional service, competitive pricing, and unwavering dedication to their success.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                  <i className="ri-award-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">15+</p>
                  <p className="text-sm text-gray-600">Premium Products</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                  <i className="ri-team-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">500+</p>
                  <p className="text-sm text-gray-600">Happy Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
